import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';

export default class PassordResetCode424 extends Component {
    constructor(props) { super(props); }
    render() {
        const { service, type } = this.props;
        return (
            <div style={{ textAlign: 'center', fontStyle: 'italic', fontWeight: 'bold' }}>
                <span style={{ fontSize: '20px' }}>
                    {'Invalid old password.'}
                </span>
                <div style={{ fontSize: '12px', fontWeight: 'normal', marginTop: '3px' }}>
                    {'Please use the correct old password.'}
                </div>
                <div style={{ margin: '20px 0px 0px 0px' }}>
                    <Button
                        icon='info-circle-o'
                        size='small'
                        onClick={service}
                        style={{ width: '200px', borderRadius: '20px' }}
                    >
                        {'Ok'}
                    </Button>
                </div>
            </div>
        );
    }
}
